import { GET, PATCH, POST } from "../../../helper/xbi4RestFunctions";
export const insert_timesheet = async (org_id: any,created_by:any,project_id:any, data: any) => {
  const path = `/orgs/${org_id}/create_timesheet/${created_by}/project/${project_id}`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      alert("error in submitting the time sheet")
      console.log(err,"erro from time sheet")
      return err;
    });
};
